"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryMethod = void 0;
exports.deliveryMethod = { "POSTMAIL": { "name": { "code": "POSTMAIL", "localize": { "en": "Postmail", "th": "ไปรษณ๊ย์" } } }, "EMAIL": { "name": { "code": "EMAIL", "localize": { "en": "Email", "th": "อีเมล์" } } } };
